import { ADMIN_LOGOUT_URL } from "../constants";

export default function Logout() {
  return (
    <a href={ADMIN_LOGOUT_URL} className="header__link">
      Logout
    </a>
  );
}
